import { render, staticRenderFns } from "./BaseNotificationModal.vue?vue&type=template&id=8128435c&"
import script from "./BaseNotificationModal.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports